/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import * as tsx from 'vue-tsx-support';
import { FontAwesomeIcon } from '@/components/Icon';
import { NotificationStore } from '@/store';
import * as utils from '@/utils';
// @ts-expect-error: This component is not in typescript yet.
import InnerUserNotifications from './InnerUserNotifications';
export default tsx.component({
    name: 'user-notifications',
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            showNotificationSettings: false,
        };
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        hasUnreadNotifications() {
            return NotificationStore.getHasUnreadNotifications();
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        markAllNotificationsAsRead() {
            return NotificationStore.dispatchMarkAllAsRead();
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        toggleNotificationSettings() {
            this.showNotificationSettings = !this.showNotificationSettings;
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return (<b-card no-body>
                <div class="card-header py-2 align-items-center justify-content-between d-flex">
                    <div class={{ 'py-1': !this.hasUnreadNotifications }}>Notifications</div>

                    <div>
                        {utils.ifOrEmpty(this.hasUnreadNotifications, () => (<cg-submit-button submit={this.markAllNotificationsAsRead} class="py-1" label="Mark all as read"/>))}
                        <b-btn onClick={this.toggleNotificationSettings} class="py-1" variant={this.showNotificationSettings ? 'primary' : 'secondary'} aria-expanded={this.showNotificationSettings} aria-controls="notification-settings-panel">
                            <FontAwesomeIcon icon={faGear}/>
                        </b-btn>
                    </div>
                </div>

                <div class="user-notifications-card" id="notification-settings-panel" aria-hidden={!this.showNotificationSettings}>
                    <InnerUserNotifications show-settings={this.showNotificationSettings}/>
                </div>
            </b-card>);
    },
});
